// removed by extract-text-webpack-plugin
module.exports = {"binary_table":"_186j8e9bOBPyB5F1LvHKKY","inner_html_container":"_3OdzMEhVO16gZwV8Pi18sR","inner_html":"US9hd2BK8gOUEtFzEMgdT","binary_table_title":"ho0z0U9gNEkYjJbBfi9fv","binary_table_item":"_1nHbzZ6EnvtEhmO_msOak","binary_table_item_col":"_2n_Y24a0F13ELR1LGeTsZA","NoDataAvailable":"_34J7K83pM3VzrJJbGCq-R-","NoDataAvailableCustom":"_2JbsnZbGADoiZ-5ICger-7"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryTable/BinaryTable.scss
// module id = 2190
// module chunks = 1